import { handleError as n } from "@propify-tenant-client/services";
import i from "query-string";
const u = (r) => i.parse(r.search);
function o() {
  var r;
  return i.parse(((r = window.location) == null ? void 0 : r.href.split("?")[1]) || "");
}
function l(r) {
  const { redirect: t } = i.parse(r);
  return t ? `?${i.stringify({ redirect: t })}` : "";
}
function f() {
  try {
    const r = new URL(window.location.href), t = o();
    let { redirect: e } = t;
    if (e) {
      if (e[0] === "/")
        return e;
      if (new URL(e).origin === r.origin)
        return e = e.substring(r.origin.length), e;
    }
  } catch (r) {
    n(r, { displayToast: !1 });
  }
  return null;
}
export {
  u as getLocationParams,
  o as getPageQuery,
  l as getRedirectString,
  f as securityRedirect
};
//# sourceMappingURL=urls.js.map
